// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[data-v-1bde2ea0]{display:inline-block;text-align:center}.icon-payment-methods[data-v-1bde2ea0]{background-image:url(\"/images/membership/icon-payment-methods.png?v=180401\");background-repeat:no-repeat;background-position:0px 0px;background-size:90px 20px;display:inline-block;width:90px;height:20px}\n", ""]);
// Exports
module.exports = exports;
